import { useContext } from 'react';
import { AppContext } from '@/context/AppContext';

export function useScan() {
  const { isScanning, scanStatus, startScan, stopPolling, activeClientId } = useContext(AppContext);

  const handleScan = () => startScan(activeClientId);
  const handleCancel = () => stopPolling();

  return { isScanning, scanStatus, startScan: handleScan, cancelScan: handleCancel };
}
